import { useState } from "react";

export default function Avatar({
                                   src,
                                   alt = "",
                                   name = "",
                                   size = "md", // "sm" | "md" | "lg"
                                   className = "",
                                   ring = false,
                               }) {
    const [err, setErr] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const sizes = {
        // un poco más pequeño en mobile, igual que antes en sm+
        sm: "h-7 w-7 text-[11px] sm:h-8 sm:w-8 sm:text-xs",
        md: "h-9 w-9 text-xs sm:h-10 sm:w-10 sm:text-sm",
        lg: "h-10 w-10 text-sm sm:h-12 sm:w-12 sm:text-base",
    };

    const initials =
        name
            ?.trim()
            ?.split(/\s+/)
            .slice(0, 2)
            .map((w) => w[0]?.toUpperCase())
            .join("") || "–";

    return (
        <div
            className={[
                "rounded-md overflow-hidden bg-gray-100 dark:bg-white/5 flex items-center justify-center select-none relative",
                sizes[size] ?? sizes.md,
                ring ? "ring-2 ring-primary" : "",
                className,
            ].join(" ")}
        >
            {!err && src && (
                <img
                    src={src}
                    alt={alt || name}
                    className={[
                        "absolute inset-0 h-full w-full object-cover transition-opacity duration-300",
                        loaded ? "opacity-100" : "opacity-0"
                    ].join(" ")}
                    onLoad={() => setLoaded(true)}
                    onError={() => setErr(true)}
                    loading="lazy"
                />
            )}
            
            {(err || !src) && (
                <span className="text-foreground-light/40 dark:text-foreground-dark/40 font-bold uppercase">
                    {initials !== "–" ? initials : ""}
                </span>
            )}
        </div>
    );
}